import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconSvgComponent } from '../../../icon/icon.component';

@Component({
  imports: [CommonModule, IconSvgComponent],
  standalone: true,
  selector: 'rx-calendar-input',
  templateUrl: './calendar-input.component.html',
    styleUrls: ['./calendar-input.component.scss'],
})
export class CalendarInputComponent {
  @Input() dateLabel: string;
  @Input() placeholder: string;
  @Input() fromDate: Date;
  @Input() toDate: Date;
  @Input() dateFormat: string;
  @Input() isOpen: boolean;
  @Input() testIdPrefix: string;
  @Input() compact: boolean;
}
